import { formatPastDate } from 'shared/utils';

/**
 * customer must be at least 13 years old
 * date-fns uses different date format strings that Moment.js
 * @see https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 */
export const getMaxBirthDate = () =>
    formatPastDate(new Date(), 'y-MM-dd', { years: 13 });
